import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";
import { Resize, Ripple } from "vuetify/lib/directives";

Vue.use( Vuetify, {
	directives: {
		Resize,
		Ripple
	}
} );

export default new Vuetify( {
	icons: { iconfont: "md" },
	options: { variations: false },
	theme: {
		themes: {
			light: {
				primary: colors.red.darken2,
				accent: colors.blue.darken1,
				secondary: colors.grey.darken3,
				info: colors.blue.darken1,
				warning: colors.amber.lighten2,
				error: colors.red.lighten1,
				success: colors.green.darken1,
				link: colors.blue.lighten1
			},
			dark: {
				primary: colors.red.darken2,
				accent: colors.blue.darken1,
				secondary: colors.grey.darken3,
				info: colors.blue.darken1,
				warning: colors.amber.lighten2,
				error: colors.red.lighten2,
				success: colors.green.darken1,
				link: colors.lightBlue.base
			}
		}
	}
} );
